/* eslint-disable no-undef,no-param-reassign,import/named,consistent-return */
/**
 * Created by chengzhenfu on 2019/5/5.
 * Modified by  on .
 *axios 封装
 */
import baseURL from '@/configs/baseUrl';
import Axios from 'axios';
import router from '@/router/index';
import utils from '@/jslibs/utils';
const fetch = Axios.create({
	withCredentials: false,
	baseURL
	// timeout: 200000, // 设置超时时间
});
let loading;
//请求发送前拦截，根据地址重新配置域名，再子路由请求时必须加/ 例如：请求 localhost:80/app/inset  fetch.get('/app/inset');
fetch.interceptors.request.use(function(config) {
	const token = (config.headers && config.headers['X-Access-Token']) || utils.getCookie('authorization');
	config.headers = Object.assign({}, config.headers, {
		'X-Access-Token': token
	});
	return config;
}, function(error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});

// 添加响应拦截器
fetch.interceptors.response.use(function(response) {
	// loading.close();
	return response;
}, function(error) {
	// 对响应错误做点什么
	console.log(error, 'error');
	//  loading.close();
	const {
		status,
		data
	} = error.response;
	switch (status) {
		case 401:
		case 412:
			if (router.currentRoute && router.currentRoute.path === '/h5Video') {
				return Promise.reject(error);
			}
			router.push('/login');
			vm.$message(data.error.message);
			break;
		case 400:
			vm.$message(data.error.message);
			return {
				status,
				data
			};
			break;
		default:
			vm.$message(data.error.message);
			return Promise.reject(data);
	}
});

export default fetch;
